import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
//
import { useForm } from "react-hook-form";
//
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
//
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import DialogForm from "components/dialogForm";
import FormField from "components/formField";

export const GET_COOPERATIVE_NAME = gql`
  query GetCooperative($id: ID!) {
    cooperative(id: $id) {
      businessName
    }
  }
`;

export const CREATE_JOB_DESCRIPTION = gql`
  mutation CreateJobDescription($input: CreateJobDescriptionInput!) {
    createJobDescription(input: $input) {
      code
      success
      message
    }
  }
`;

export default function() {
  const { id } = useParams();

  const {
    data: queryData,
    loading: queryLoading,
    error: queryError
  } = useQuery(GET_COOPERATIVE_NAME, {
    variables: { id }
  });

  const [
    createJobDescription,
    { data: mutationData, loading: mutationLoading, error: mutationError }
  ] = useMutation(CREATE_JOB_DESCRIPTION);

  const { register, handleSubmit, formState, errors } = useForm({
    //mode: "onChange"
  });

  const onSubmit = data => {
    //const { code, agreementDate, startDate } = data;
    const { } = data;

    const variables = {
      input: {
        cooperative: queryData.cooperative.businessName,
        /*type: code,
        template: "???",
        agreementDate,
        startDate*/
      }
    };

    createJobDescription({
      variables
    });
  };

  if (queryError) return <p>ERROR: {queryError.message}</p>;

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={mutationLoading}
        message={"Creazione del mansionario avviata con successo."}
      />
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={Boolean(mutationError)}
        message={"Si è verificato un errore nella creazione del mansionario."}
      /> 
      <DialogForm
        id="create-job-description"
        title={
          queryData &&
          `Creazione Mansionari ${queryData.cooperative.businessName}`
        }
        subTitle={queryData && `La seguente procedura avvierà la creazione del mansionario per la società ${queryData.cooperative.businessName}, saranno escluse tutte le matricole NON attive e/o con data di cessazione del contratto antecedente al primo giorno del mese di riferimento.`}
        buttonTitle='Crea mansionario'
        formState={formState}
        onSubmit={handleSubmit(onSubmit)}
      >
          {/* <FormField
            id="code"
            name="code"
            label="Codice"
            type="text"
            inputRef={register({ required: "Inserisci il codice." })}
            error={errors.password}
          />
          <FormField
            id="stip"
            name="agreementDate"
            label="Data stipula"
            type="date"
            inputRef={register({ required: "Inserisci data di stipula." })}
            error={errors.password}
          />
          <FormField
            id="start"
            name="startDate"
            label="Data inizio"
            type="date"
            inputRef={register({ required: "Inserisci data di inizio." })}
            error={errors.password}
          /> */}
      </DialogForm>
    </Fragment>
  );
}
